import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogBinReducer } from "./CatalogBinReducer";

const CatalogBinContext = createContext({
  state: CatalogBinReducer.getInitialState(),
  actions: CatalogBinReducer.actions,
});

export const useCatalogBinContext = () => useContext(CatalogBinContext);

export const CatalogBinProvider = ({ children }: { children: ReactNode }) => {
  const [state, actions] = useComplexState({
    initialState: CatalogBinReducer.getInitialState(),
    reducers: CatalogBinReducer.caseReducers,
  });
  return (
    <CatalogBinContext.Provider value={{ state, actions }}>
      {children}
    </CatalogBinContext.Provider>
  );
};
